import relativesApi from '@/api/relatives';

const state = {
    listRelatives: null,
    listRelativesTypes: null,
    relativesCreated: null,
    relativesUpdated: null,
    relativesRemoved: null,
    isLoading: false,
    validationErrors: null,
}

export const mutationTypes = {
    getRelativesListStart: '[relativesList] Get relatives list start',
    getRelativesListSuccess: '[relativesList] Get relatives list success',
    getRelativesListFailure: '[relativesList] Get relatives list failure',

    getRelativesTypesListStart: '[relativesTypesList] Get relatives types list start',
    getRelativesTypesListSuccess: '[relativesTypesList] Get relatives types list success',
    getRelativesTypesListFailure: '[relativesTypesList] Get relatives types list failure',

    relativesAddStart: '[relatives] Create relatives start',
    relativesAddSuccess: '[relatives] Create relatives success',
    relativesAddFailure: '[relatives] Create relatives failure',

    relativesEditStart: '[relatives] Update relatives start',
    relativesEditSuccess: '[relatives] Update relatives success',
    relativesEditFailure: '[relatives] Update relatives failure',

    relativesRemoveStart: '[relatives] Remove relatives start',
    relativesRemoveSuccess: '[relatives] Remove relatives success',
    relativesRemoveFailure: '[relatives] Remove relatives failure',
}

export const relativesActionTypes = {
    getRelativesList: '[relativesList] Get relatives list',
    getRelativesTypesList: '[relativesTypesList] Get relatives types list',
    relativesAdd: '[relatives] Create relatives',
    relativesEdit: '[relatives] Update relatives',
    relativesRemove: '[relatives] Remove relatives'
}

const mutations = {
    [mutationTypes.getRelativesListStart](state) {
        state.isLoading = true
        state.listRelatives = null
    },
    [mutationTypes.getRelativesListSuccess](state, payload) {
        state.isLoading = false
        state.listRelatives = payload
        state.validationErrors = null
    },
    [mutationTypes.getRelativesListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getRelativesTypesListStart](state) {
        state.isLoading = true
        state.listRelativesTypes = null
    },
    [mutationTypes.getRelativesTypesListSuccess](state, payload) {
        state.isLoading = false
        state.listRelativesTypes = payload
        state.validationErrors = null
    },
    [mutationTypes.getRelativesTypesListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.relativesAddStart](state) {
        state.isLoading = true
        state.relativesCreated = null
    },
    [mutationTypes.relativesAddSuccess](state, payload) {
        state.isLoading = false
        state.relativesCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.relativesAddFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.relativesEditStart](state) {
        state.isLoading = true
        state.relativesUpdated = null
    },
    [mutationTypes.relativesEditSuccess](state, payload) {
        state.isLoading = false
        state.relativesUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.relativesEditFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.relativesRemoveStart](state) {
        state.isLoading = true
        state.relativesRemoved = null
    },
    [mutationTypes.relativesRemoveSuccess](state, payload) {
        state.isLoading = false
        state.relativesRemoved = payload
        state.validationErrors = null
    },
    [mutationTypes.relativesRemoveFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    }
}

const actions = {
    [relativesActionTypes.getRelativesList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getRelativesListStart)
            relativesApi
                .getRelativesList(data)
                .then(response => {
                    context.commit(mutationTypes.getRelativesListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getRelativesListFailure,response)
                })
        })
    },
    [relativesActionTypes.getRelativesTypesList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getRelativesTypesListStart)
            relativesApi
                .getRelativesTypesList(data)
                .then(response => {
                    context.commit(mutationTypes.getRelativesTypesListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getRelativesTypesListFailure,response)
                })
        })
    },
    [relativesActionTypes.relativesAdd](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.relativesAddStart)
            relativesApi
                .relativesAdd(data)
                .then(response => {
                    context.commit(mutationTypes.relativesAddSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.relativesAddFailure,response)
                })
        })
    },
    [relativesActionTypes.relativesEdit](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.relativesEditStart)
            relativesApi
                .relativesEdit(data)
                .then(response => {
                    context.commit(mutationTypes.relativesEditSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.relativesEditFailure,response)
                })
        })
    },
    [relativesActionTypes.relativesRemove](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.relativesRemoveStart)
            relativesApi
                .relativesRemove(data)
                .then(response => {
                    context.commit(mutationTypes.relativesRemoveSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.relativesRemoveFailure,response)
                })
        })
    }
}

export default {
    state,
    actions,
    mutations
}